/**
 * @generated SignedSource<<72c07c6492a1f550929d9ce0343711c4>>
 * @relayHash e3a5e83ffea42110635e281877689ab6
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 8f90acb10056811684bf81e275459c057c92c7813f1a54be859db5b29676c114

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraGroupByDropdownFilter = {
  projectId?: string | null | undefined;
  searchString?: string | null | undefined;
};
export type mainGroupByDropdownWithSearchQuery$variables = {
  filter?: JiraGroupByDropdownFilter | null | undefined;
  nodeId: string;
};
export type mainGroupByDropdownWithSearchQuery$data = {
  readonly node: {
    readonly __typename: string;
    readonly id: string;
    readonly viewSettings?: {
      readonly groupByConfig: {
        readonly " $fragmentSpreads": FragmentRefs<"main_issueTableGroupByDropdown_GroupByDropdownWithSearch_groupByConfig">;
      } | null | undefined;
    } | null | undefined;
    readonly " $fragmentSpreads": FragmentRefs<"main_issueTableGroupByDropdown_GroupByDropdownWithSearch_view">;
  } | null | undefined;
};
export type mainGroupByDropdownWithSearchQuery = {
  response: mainGroupByDropdownWithSearchQuery$data;
  variables: mainGroupByDropdownWithSearchQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "filter"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "nodeId"
},
v2 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "nodeId"
  }
],
v3 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v4 = {
  "kind": "ScalarField",
  "name": "id"
},
v5 = [
  {
    "kind": "FragmentSpread",
    "name": "main_issueTableGroupByDropdown_GroupByDropdownWithSearch_view"
  },
  {
    "concreteType": "JiraIssueSearchViewConfigSettings",
    "kind": "LinkedField",
    "name": "viewSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
          {
            "kind": "FragmentSpread",
            "name": "main_issueTableGroupByDropdown_GroupByDropdownWithSearch_groupByConfig"
          }
        ]
      }
    ]
  }
],
v6 = {
  "kind": "Variable",
  "name": "filter",
  "variableName": "filter"
},
v7 = {
  "kind": "ScalarField",
  "name": "fieldId"
},
v8 = {
  "kind": "ScalarField",
  "name": "name"
},
v9 = {
  "kind": "ScalarField",
  "name": "typeKey"
},
v10 = [
  (v6/*: any*/),
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v11 = [
  {
    "concreteType": "JiraIssueSearchViewConfigSettings",
    "kind": "LinkedField",
    "name": "viewSettings",
    "plural": false,
    "selections": [
      {
        "concreteType": "JiraSpreadsheetGroupByConfig",
        "kind": "LinkedField",
        "name": "groupByConfig",
        "plural": false,
        "selections": [
          {
            "args": [
              (v6/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 5
              }
            ],
            "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
            "kind": "LinkedField",
            "name": "recentlyUsed",
            "plural": false,
            "selections": [
              {
                "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v9/*: any*/),
                      (v4/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  {
    "kind": "InlineFragment",
    "selections": [
      {
        "concreteType": "JiraIssueSearchViewConfigSettings",
        "kind": "LinkedField",
        "name": "viewSettings",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraSpreadsheetGroupByConfig",
            "kind": "LinkedField",
            "name": "groupByConfig",
            "plural": false,
            "selections": [
              {
                "args": (v10/*: any*/),
                "concreteType": "JiraSpreadsheetGroupByFieldOptionConnection",
                "kind": "LinkedField",
                "name": "availableGroupByFieldOptions",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraSpreadsheetGroupByFieldOptionEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "JiraField",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          (v8/*: any*/),
                          (v9/*: any*/),
                          (v4/*: any*/),
                          (v3/*: any*/)
                        ]
                      },
                      {
                        "kind": "ScalarField",
                        "name": "cursor"
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "endCursor"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              },
              {
                "args": (v10/*: any*/),
                "filters": [
                  "filter"
                ],
                "handle": "connection",
                "key": "RefetchIssueTableGroupByOptionsQuery_availableGroupByFieldOptions",
                "kind": "LinkedHandle",
                "name": "availableGroupByFieldOptions"
              }
            ]
          }
        ]
      }
    ],
    "type": "JiraSpreadsheetView",
    "abstractKey": "__isJiraSpreadsheetView"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainGroupByDropdownWithSearchQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v5/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainGroupByDropdownWithSearchQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v3/*: any*/),
          (v4/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraGroupedListView"
          },
          {
            "kind": "InlineFragment",
            "selections": (v11/*: any*/),
            "type": "JiraListView"
          }
        ]
      }
    ]
  },
  "params": {
    "id": "8f90acb10056811684bf81e275459c057c92c7813f1a54be859db5b29676c114",
    "metadata": {},
    "name": "mainGroupByDropdownWithSearchQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "9938681abc0d49a19f7a25f54d75421a";

export default node;
